import { Component, Input } from '@angular/core';

import { MenuProduct } from 'src/app/shared/model/MenuProduct';
import { FooterListItem } from '../complements-footer.component';
import { Option } from 'src/app/shared/model/Option';

@Component({
    selector: 'app-footer-list',
    templateUrl: './footer-list.component.html',
    styleUrls: ['./footer-list.component.scss'],
})
export class FooterListComponent {
    @Input() item: MenuProduct;
    @Input() items: (Option | FooterListItem)[] = [];
}
